import PropTypes from 'prop-types'
import React from 'react'

import ResultsHeroContent from '../content/results'
import Hero from '../hero'
import LocalHero from '~/components/hero/content/local'
import { usePageContext } from '~/contexts/page-context'
import { decideHeroText } from '~/utils/hero-copy'
import { sentenceCase } from '~/utils/string'

const ResultsHero = ({
  currentProvider,
  headerImage,
  headerText,
  onUpdate,
  p0 = null,
  postcode,
  title,
  address,
  loading,
  children,
  p0Fetched = false,
  hideP0Image = true
}) => {
  const { locality, pageId } = usePageContext()

  if (!locality)
    return (
      <Hero p0={p0} p0Fetched={p0Fetched} hideP0Image={hideP0Image}>
        <ResultsHeroContent
          currentProvider={currentProvider}
          headerImage={headerImage}
          headerText={headerText || decideHeroText(pageId, null)}
          onUpdate={onUpdate}
          postcode={postcode}
          title={title}
          address={address}
          loading={loading}
          p0={p0}
          p0Fetched={p0Fetched}
          hideP0Image={hideP0Image}
        >
          {children}
        </ResultsHeroContent>
      </Hero>
    )

  return (
    <LocalHero
      customerAddress={address}
      currentProvider={currentProvider}
      headerText={decideHeroText(pageId, locality)}
      onUpdate={onUpdate}
      loading={loading}
      title={`Broadband in ${sentenceCase(locality)}`}
    >
      {children}
    </LocalHero>
  )
}

ResultsHero.propTypes = {
  currentProvider: PropTypes.string,
  headerImage: PropTypes.object,
  headerText: PropTypes.string,
  onUpdate: PropTypes.func,
  p0: PropTypes.object,
  postcode: PropTypes.string,
  title: PropTypes.string
}

export default ResultsHero
